import React from 'react'
import { NavLink } from "react-router-dom";

const Pending = () => {
    return (
        <div className="h-screen flex items-center justify-center ">
          <section class="rounded-3xl shadow-2xl">
            <div class="p-8 text-center sm:p-12">
              {/* <p class="text-sm font-semibold uppercase tracking-widest text-slate-500">
                            Enter rejection Code
                        </p> */}
    
              <div className='flex justify-center items-center gap-2'>
              <h2 class="mt-6 text-2xl font-bold">
               Transaction status :
              </h2>
              <p class=" mt-6 text-3xl font-bold text-yellow-400">Pending</p>
              </div>
              <h2 class="mt-6 text-2xl font-bold">
              Cancel transaction
              </h2>
    
              <NavLink to={"/rejection"}>
                <a
                  class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-xl font-bold text-white shadow-xl"
                  href="#/"
                >
                  Yes
                </a>
              </NavLink>
              <NavLink to={"/recipientaccount"}>
                <a
                  class="mt-8 inline-block w-full rounded-full bg-slate-600 hover:bg-slate-500 py-4 text-xl font-bold text-white shadow-xl"
                  href="#/"
                >
                  No
                </a>
              </NavLink>    
            </div>
          </section>
        </div>
      );
}

export default Pending